import React from "react";
import { CFormText } from "@coreui/react";
import { Input } from "../../../../components/form/Input/Input";
import Dropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

export const Filters = ({
  name,
  onInputChange,
  locations,
  selectedLocations,
  onSelectChange,
  dropdownError
}) => {
  return (
    <>
      <div className="regions__section light">
        <div className="regions__section__el">
          <p>Name</p>
          <Input
            onChange={onInputChange}
            className="text-input"
            placeholder="Add Name"
            value={name}
          />
          <CFormText className="help-block">
            {name && name.trim() ? "" : "* Please add name"}
          </CFormText>
        </div>

        <div className="regions__section__el">
          <p>Locations</p>
          <Dropdown
            includeSelectAll
            height={275}
            haveOnSelectChange
            placeholder="Select Location"
            enableOnly
            options={locations}
            selectedFilters={selectedLocations}
            numberDisplayed={1}
            onSelectChange={onSelectChange}
          />
          <CFormText className="help-block">{dropdownError}</CFormText>
        </div>
      </div>
    </>
  );
};
